// extracted by mini-css-extract-plugin
export default {"md":"mackdown_md__So6P4","table":"mackdown_table__rIytD"};